<template>
  <div>
    <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-200 mb-8">
      <h1 class="text-4xl">
        our history
      </h1>
    </div>
    <div class="row flex box-our relative flex-wrap">
      <div class="w-full">
        <div class="mx-auto max-w-[700px]">
          <swiper
              class="mt-[40px] md:mt-0 mb-5"
              :modules="[Navigation, Pagination, Scrollbar, A11y, Autoplay]"
              :slides-per-view="1"
              :space-between="50"
              :pagination="{ clickable: true }"
              :navigation="{ clickable: true }"
              :autoplay="{delay: 10000}"
          >
            <swiper-slide v-for="(image, index) in images" :key="index"
                          class="flex flex-col justify-center items-center"

            >
              <img
                  alt=""
                  :src="
                  usePhoto(
                    '/storage/images/our-history/' +
                      album_path +
                      '/thumbnail_cache/' +
                      image.hash
                  )
                "
                  width="300"
              />
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="row">
        <div class="text-paragraph mb-5" v-html="paragraphs"></div>
      </div>
    </div>

  </div>
</template>

<script setup>

import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import {http} from "~/utils/http";
import { usePhoto } from "~/composables";
import {ref} from 'vue';

const paragraphs = ref('');
const images = ref(null);
const album_path = ref(null);



const getHistoryContent = async () => {
  try {
    await http.get("/api/our-history").then((json) => {

      paragraphs.value = (json.data.pageContent);
      album_path.value = (json.data.albumPath);
      images.value = (json.data.images);
    });
  } catch (e) {}
};

getHistoryContent();
</script>
